// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const API = "https://server.havbit.in/api/vendor/brands/public";

// export default function BrandsDropdown() {
//   const [brands, setBrands] = useState([]);
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   // Fetch API
//   useEffect(() => {
//     fetch(API)
//       .then(res => res.json())
//       .then(data => {
//         const list = data?.data || [];
//         setBrands(list);
//       })
//       .catch(err => console.log("API error:", err));
//   }, []);

//   // Listen from Footer
//   useEffect(() => {
//     const handler = () => setOpen(true);
//     window.addEventListener("openBrands", handler);
//     return () => window.removeEventListener("openBrands", handler);
//   }, []);

//   // ✅ Brand click handler - navigate to products with brand filter
//   const handleBrandClick = (brandName) => {
//     setOpen(false);
//     navigate(`/products?brand=${encodeURIComponent(brandName)}`);
//   };

//   if (!open) return null;

//   return (
//     <div style={overlay}>
//       <div style={modal}>

//         {/* Header */}
//         <div style={header}>
//           <h2>All Brands</h2>
//           <button onClick={() => setOpen(false)} style={closeBtn}>✖</button>
//         </div>

//         {/* Grid */}
//         <div style={grid}>
//           {brands.length > 0 ? (
//             brands.map((b, i) => (
//               <div
//                 key={i}
//                 style={card}
//                 onClick={() => handleBrandClick(b.brandName)}
//                 onMouseEnter={e => {
//                   e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
//                   e.currentTarget.style.cursor = "pointer";
//                   e.currentTarget.style.borderColor = "#e11d48";
//                 }}
//                 onMouseLeave={e => {
//                   e.currentTarget.style.boxShadow = "none";
//                   e.currentTarget.style.borderColor = "#eee";
//                 }}
//               >
//                 <img
//                   src={b.logo?.url || "https://via.placeholder.com/100"}
//                   alt={b.brandName}
//                   style={img}
//                 />
//                 <p style={name}>{b.brandName}</p>
//               </div>
//             ))
//           ) : (
//             <p>Loading brands...</p>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// }

// /* 🎨 Styles */

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.5)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   zIndex: 9999
// };

// const modal = {
//   background: "#fff",
//   width: "90%",
//   maxWidth: "1200px",
//   padding: "20px",
//   borderRadius: "12px",
//   maxHeight: "80vh",
//   overflowY: "auto"
// };

// const header = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   marginBottom: "20px"
// };

// const grid = {
//   display: "grid",
//   gridTemplateColumns: "repeat(4, 1fr)",
//   gap: "20px"
// };


// const card = {
//   padding: "10px",
//   cursor: "pointer",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   transition: "0.3s"
// };


// const img = {
//   height: "60px",
//   width: "60px",
//   objectFit: "cover",
//   borderRadius: "50%",
//   marginBottom: "10px",
//   background: "transparent",   // ✅ add this
// };

// const name = {
//   fontSize: "14px",
//   textAlign: "center"
// };

// const closeBtn = {
//   border: "none",
//   background: "transparent",
//   fontSize: "18px",
//   cursor: "pointer"
// };






















import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://server.havbit.in/api/vendor/brands/public";

export default function BrandsDropdown() {
  const [brands, setBrands] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Fetch API
  useEffect(() => {
    fetch(API)
      .then(res => res.json())
      .then(data => {
        const list = data?.data || [];
        setBrands(list);
      })
      .catch(err => console.log("API error:", err));
  }, []);

  // Listen from Footer
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("openBrands", handler);
    return () => window.removeEventListener("openBrands", handler);
  }, []);

  // Brand click
  const handleBrandClick = (brandName) => {
    setOpen(false);
    navigate(`/products?brand=${encodeURIComponent(brandName)}`);
  };

  if (!open) return null;

  return (
    <div style={overlay}>
      
      {/* FULL SCREEN CONTAINER */}
      <div style={fullScreen}>

        {/* HEADER */}
        <div style={header}>
          <h2 style={{ fontSize: "20px", fontWeight: "600" }}>
            All Brands
          </h2>

          <button onClick={() => setOpen(false)} style={closeBtn}>
            ✖
          </button>
        </div>

        {/* GRID */}
        <div style={grid}>
          {brands.length > 0 ? (
            brands.map((b, i) => (
              <div
                key={i}
                style={card}
                onClick={() => handleBrandClick(b.brandName)}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <img
                  src={b.logo?.url || "https://via.placeholder.com/100"}
                  alt={b.brandName}
                  style={img}
                />
                <p style={name}>{b.brandName}</p>
              </div>
            ))
          ) : (
            <p>Loading brands...</p>
          )}
        </div>

      </div>
    </div>
  );
}

/* 🎨 FULL SCREEN STYLES */

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "#fff",   // 🔥 NO DARK OVERLAY
  zIndex: 9999
};

const fullScreen = {
  width: "100%",
  height: "100%",
  padding: "30px",
  overflowY: "auto"
};

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "30px",
  borderBottom: "1px solid #eee",
  paddingBottom: "10px"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
  gap: "25px"
};

const card = {
  padding: "15px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  transition: "0.3s",
  cursor: "pointer"
};

const img = {
  height: "70px",
  width: "70px",
  objectFit: "cover",
  borderRadius: "50%",
  marginBottom: "10px"
};

const name = {
  fontSize: "14px",
  textAlign: "center",
  fontWeight: "500"
};

const closeBtn = {
  border: "none",
  background: "transparent",
  fontSize: "20px",
  cursor: "pointer"
};